export default {
  MapBoxToken: process.env.PUBLIC_MAPBOX_API_TOKEN,
};
